import React, {useEffect, useMemo, useState} from "react";
import {Modal, Row, Col, Table, Button} from "react-bootstrap";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {ModalProgressBar} from "../../../../_metronic/_partials/controls";
import * as actions from "../../../../redux/modules/products/actions";
import * as formatter from "../../../../utils/formatter";
import {ALLOW_STATUS, PROV_STATUS} from "../../../../utils/codes";
import {useProductsUIContext} from "../../../contexts/ProductsUIContext";
import {requestSample} from "../../../../redux/modules/samples/crud";
import {ProductImage} from "../../core/ProductImage";

import _ from "lodash";

export function ProductDetailModal({show, onHide, prodId}) {
  const context = useProductsUIContext();
  const dispatch = useDispatch();
  const {isLoading, product} = useSelector(
    (state) => ({
      isLoading: state.products.actionsLoading,
      product: state.products.product,
    }),
    shallowEqual
  );

  const {goToCreateLink} = useMemo(() => ({
    goToCreateLink: context.goToCreateLink,
  }), [context]);

  const [openSampleConfirm, setOpenConfirm] = useState(false);

  const openSampleConfirmDialog = () => {
    setOpenConfirm(true);
  };

  const handleRequestSample = async () => {
    try {
      await requestSample(product.goodsNo);
      alert('접수 되었습니다.');
      setOpenConfirm(false);
    } catch(err) {
      alert(err.message);
    }
  }

  useEffect(() => {}, [isLoading, dispatch]);
  useEffect(() => {
    if (prodId) {
      dispatch(actions.fetchProduct(prodId));
    }
  }, [prodId, dispatch]);

  const format = useMemo(() => ({
    ChipFormatter: formatter.chip(ALLOW_STATUS),
    DotFormatter: formatter.dot(PROV_STATUS),
    DateFormatter: formatter.dateTime,
    ArrayFormatter: formatter.join(" > "),
    PriceFormatter: formatter.price,
    CountFormatter: formatter.count,
    CategoryFormatter: formatter.category,
    OptionsFormatter: formatter.goodsDetailOpt,
  }), []);

  if (!product) return null;

  const images = _.sortBy(product.goodsImgList, img => img.reprYn !== 'Y');

  return (
    <>
      <Modal
        show={show && !openSampleConfirm}
        onHide={onHide}
        size="xl"
        aria-labelledby="example-modal-sizes-title-lg"
        centered
      >
        {isLoading && <ModalProgressBar/>}
        <Modal.Header>
          <div>
            <h3>상품 상세</h3>
            <span className="text-dark-50">공급파트너가 등록한 상품 상세 정보를 확인하세요.</span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12} lg={4}>
              <Row>
                {images.map((img, index) => (
                  <Col xs={index === 0 ? 12 : 4} className="mb-2" key={`image-${index}`}>
                    <ProductImage src={img.imgUrl} />
                  </Col>
                ))}
              </Row>

            </Col>
            <Col md={12} lg={8}>
              <Table responsive>
                <tbody>
                <tr>
                  <th>공급상태</th>
                  <td>{format.DotFormatter(product.splySttsCd)}</td>
                  <th>등록일시</th>
                  <td>{format.DateFormatter(product.regDtime)}</td>
                </tr>

                <tr>
                  <th>상품코드</th>
                  <td>{product.goodsNo}</td>
                  <th>카테고리</th>
                  <td>{format.CategoryFormatter(null, product)}</td>
                </tr>

                <tr>
                  <th>상품명</th>
                  <td colSpan={3}>{product.goodsNm}</td>
                </tr>

                <tr>
                  <th>정가</th>
                  <td>{format.PriceFormatter(product.normalPrc)}</td>
                  <th>공급가</th>
                  <td>{format.PriceFormatter(product.salePrc)}</td>
                </tr>

                <tr>
                  <th>옵션</th>
                  <td colSpan={3}>{format.OptionsFormatter(product.goodsOptList)}</td>
                </tr>

                <tr>
                  <th>상품참고 url</th>
                  <td colSpan={3}>
                    <a
                      target="_blank"
                      className="break-all"
                      rel="noopener noreferrer"
                      href={product.goodsRefUrl}
                    >
                      {product.goodsRefUrl}
                    </a>
                  </td>
                </tr>

                <tr>
                  <th>공급파트너</th>
                  <td colSpan={3}>{product.splyNm} ({product.splyId})</td>
                </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              variant="warning"
              className="btn-elevate w-130px mr-5"
              onClick={openSampleConfirmDialog}
            >
              샘플신청
            </Button>
            <Button
              variant="success"
              className="btn-elevate w-130px"
              onClick={e => goToCreateLink(e, product.goodsNo)}
            >
              판매등록
            </Button>
          </div>
        </Modal.Footer>
      </Modal>


      <Modal
        size="sm"
        show={openSampleConfirm}
        onHide={onHide}
        centered
      >
        <Modal.Body>
          <div className="text-center">
            해당 제품 샘플을 신청하시겠습니까?
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="secondary"
            size="sm"
            className="btn-elevate w-100px mr-5"
            onClick={() => setOpenConfirm(false)}
          >
            취소
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="btn-elevate w-100px"
            onClick={handleRequestSample}
          >
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
